import React from 'react'
import {
  type PatientStaffApiOutContract,
  type VisitDoctorApiOutContract,
  type WaitingRoomV2VisitListItemDoctorApiOutContract,
} from 'api/generated/pwrdbyQuickMDProvidersApi.schemas'
import { type PatientWithVisitInfo } from 'types/types'

export const usePatientVisitInfo = (
  selectedPatientInformation: PatientStaffApiOutContract | undefined,
  selectedVisitInformation: VisitDoctorApiOutContract | undefined,
  selectedVisit?: WaitingRoomV2VisitListItemDoctorApiOutContract,
): PatientWithVisitInfo =>
  React.useMemo(() => {
    const base = {
      ...(selectedPatientInformation || {}),
      PatientName:
        `${selectedPatientInformation?.FirstName ?? ''} ${selectedPatientInformation?.LastName ?? ''}`.trim(),
      VisitTime: selectedVisitInformation?.FromDateTime,
      ServiceName: selectedVisitInformation?.ServiceTypeName,
      VisitName: selectedVisitInformation?.VisitTypeName,
      ServiceTypeCategory: selectedVisitInformation?.ServiceTypeCategory,
      ServiceTypeAbbreviation: selectedVisit?.ServiceTypeAbbreviation,
      VisitId: selectedVisitInformation?.VisitId,
      VisitMethod: selectedVisitInformation?.Method,
      IntakeForm: selectedVisitInformation?.IntakeForm ?? undefined,
      Questionnaires: selectedVisitInformation?.Questionnaires ?? undefined,
      StateCode: selectedPatientInformation?.Address?.StateCode ?? undefined,
    }
    const prefix = base.PhoneNumber?.Prefix ?? ''
    const number = base.PhoneNumber?.Number ?? ''
    const rest = number.startsWith(prefix) ? number.slice(prefix.length) : number
    const PatientNumber = `${prefix}${rest}`.trim()
    const PatientFullName = `${base?.FirstName ?? ''} ${base?.LastName ?? ''}`.trim()

    return {
      PatientName: base.PatientName ?? PatientFullName,
      PatientFullName,
      PatientNumber,
      VisitTime: base.VisitTime,
      ServiceName: base.ServiceName,
      VisitName: base.VisitName,
      VisitId: base.VisitId,
      VisitMethod: base.VisitMethod,
      IntakeForm: base.IntakeForm,
      Questionnaires: base.Questionnaires,
      StateCode: base.StateCode,
      ServiceTypeCategory: base.ServiceTypeCategory,
      ServiceTypeAbbreviation: base.ServiceTypeAbbreviation,
      ...(selectedPatientInformation || {}),
      VisitStatus: selectedVisit?.Status,
    } as PatientWithVisitInfo
  }, [selectedPatientInformation, selectedVisitInformation, selectedVisit])
